import React, {PureComponent} from 'react';
import {connect} from 'react-redux';


export default class ThanksRoute extends PureComponent {
  render() {
    const clickHere = (
      <a href="https://centralsf.org/ministries/kidcentral/" target="_blank">
        click here
      </a>
    );

    return (
      <div className="thanks-route">
        <p>
          We are SO excited you are choosing to visit Central. Our goal is to be
          as ready for you as we can be. When you get here this weekend, just
          stop by the First Step Counter in our main lobby, Grand Central. We'll
          be ready to say hi, answer questions, give you a gift, and make sure
          you feel as welcome as possible.
        </p>
        <p>
          Also, if you have kids you'd like to register for our Kid Central
          children's ministry, please {clickHere} to get them signed up! Then
          you'll be ready for check-in right away when you visit Central.
        </p>
        <p>
          *Please note that it may take up to 24 hours for our Plan Your Visit
          submissions to process. We will still be happy to welcome you at the
          First Step Counter, but we may not know you're coming if your form is
          submitted at 11:30pm on Saturday night. But we promise to do our best
          to be ready for you!
        </p>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/thanks-route/index.js